import { useEffect, useState } from 'react'
import { adminService } from 'core/services/adminService'
import { formatNumbers } from 'core/helpers/format-numbers'
import { toast } from 'react-toastify'

import c from './assets/sass/milestones-list.module.scss'

export const MilestonesList = () => {
    const [milestones, setMilestones] = useState([])
    const [cases, setCases] = useState([])
    const [loading, setLoading] = useState(true)
    const [editing, setEditing] = useState(null)
    const [form, setForm] = useState({ threshold: '', rewardType: 'case', coinAmount: '', caseId: '' })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = async () => {
        try {
            setLoading(true)
            const [mData, cData] = await Promise.all([
                adminService.getMilestones(),
                adminService.getCasesList()
            ])
            setMilestones(mData.milestones || mData.levels || [])
            setCases(cData.cases || [])
        } catch (e) {
            toast('Ошибка загрузки', { type: 'error' })
        } finally {
            setLoading(false)
        }
    }

    const handleEdit = (m) => {
        setEditing(m.id)
        setForm({
            threshold: String(m.threshold),
            rewardType: m.rewardType || 'case',
            coinAmount: String(m.coinAmount || ''),
            caseId: m.caseId || '',
        })
    }

    const handleSave = async (id) => {
        try {
            await adminService.updateMilestone(id, {
                rewardType: form.rewardType,
                coinAmount: form.rewardType === 'coins' ? parseInt(form.coinAmount) || 0 : 0,
                caseId: form.rewardType === 'case' ? form.caseId || null : null,
            })
            setEditing(null)
            toast('Сохранено', { type: 'success' })
            loadData()
        } catch (e) {
            toast('Ошибка: ' + e.message, { type: 'error' })
        }
    }

    const handleDelete = async (id) => {
        if (!window.confirm('Удалить milestone?')) return
        try {
            await adminService.deleteMilestone(id)
            toast('Удалено', { type: 'success' })
            loadData()
        } catch (e) {
            toast('Ошибка: ' + e.message, { type: 'error' })
        }
    }

    const handleCreate = async () => {
        if (!form.threshold) return toast('Укажите порог', { type: 'error' })
        try {
            await adminService.createMilestone({
                threshold: parseInt(form.threshold),
                rewardType: form.rewardType,
                coinAmount: form.rewardType === 'coins' ? parseInt(form.coinAmount) || 0 : 0,
                caseId: form.rewardType === 'case' ? form.caseId || null : null,
            })
            setForm({ threshold: '', rewardType: 'case', coinAmount: '', caseId: '' })
            toast('Создано', { type: 'success' })
            loadData()
        } catch (e) {
            toast('Ошибка: ' + e.message, { type: 'error' })
        }
    }

    if (loading) return <div className={c.loading}>Загрузка...</div>

    return (
        <div className={c.component}>
            <div className={c.createSection}>
                <div className={c.sectionTitle}>Добавить milestone</div>
                <div className={c.form}>
                    <input
                        type="number"
                        placeholder="Кол-во друзей"
                        value={form.threshold}
                        onChange={e => setForm(p => ({ ...p, threshold: e.target.value }))}
                    />
                    <select
                        value={form.rewardType}
                        onChange={e => setForm(p => ({ ...p, rewardType: e.target.value }))}
                    >
                        <option value="case">Кейс</option>
                        <option value="coins">Монеты</option>
                    </select>
                    {form.rewardType === 'coins' && (
                        <input
                            type="number"
                            placeholder="Кол-во монет"
                            value={form.coinAmount}
                            onChange={e => setForm(p => ({ ...p, coinAmount: e.target.value }))}
                        />
                    )}
                    {form.rewardType === 'case' && (
                        <select
                            value={form.caseId}
                            onChange={e => setForm(p => ({ ...p, caseId: e.target.value }))}
                        >
                            <option value="">— Выберите кейс —</option>
                            {cases.map(cs => (
                                <option key={cs.id} value={cs.id}>
                                    {cs.name} ({formatNumbers(parseInt(cs.price))} монет)
                                </option>
                            ))}
                        </select>
                    )}
                    <button onClick={handleCreate}>Создать</button>
                </div>
            </div>

            <div className={c.list}>
                {milestones.map(m => (
                    <div key={m.id} className={c.item}>
                        {editing === m.id ? (
                            <div className={c.editForm}>
                                <span className={c.thresholdLabel}>{m.threshold} друзей</span>
                                <select
                                    value={form.rewardType}
                                    onChange={e => setForm(p => ({ ...p, rewardType: e.target.value }))}
                                >
                                    <option value="case">Кейс</option>
                                    <option value="coins">Монеты</option>
                                </select>
                                {form.rewardType === 'coins' && (
                                    <input
                                        type="number"
                                        placeholder="Монет"
                                        value={form.coinAmount}
                                        onChange={e => setForm(p => ({ ...p, coinAmount: e.target.value }))}
                                    />
                                )}
                                {form.rewardType === 'case' && (
                                    <select
                                        value={form.caseId}
                                        onChange={e => setForm(p => ({ ...p, caseId: e.target.value }))}
                                    >
                                        <option value="">— Выберите кейс —</option>
                                        {cases.map(cs => (
                                            <option key={cs.id} value={cs.id}>
                                                {cs.name} ({formatNumbers(parseInt(cs.price))})
                                            </option>
                                        ))}
                                    </select>
                                )}
                                <div className={c.editActions}>
                                    <button onClick={() => handleSave(m.id)}>Сохранить</button>
                                    <button onClick={() => setEditing(null)}>Отмена</button>
                                </div>
                            </div>
                        ) : (
                            <>
                                <div className={c.itemInfo}>
                                    <span className={c.threshold}>{m.threshold} друзей</span>
                                    {m.rewardType === 'coins' ? (
                                        <span className={c.rewardCoins}>
                                            🪙 {formatNumbers(m.coinAmount)} монет
                                        </span>
                                    ) : (
                                        <span className={c.rewardCase}>
                                            🎁 {m.caseName || 'Не привязан'}
                                            {m.casePrice && ` (${formatNumbers(parseInt(m.casePrice))})`}
                                        </span>
                                    )}
                                    {m.caseImage && m.rewardType === 'case' && (
                                        <img className={c.caseThumb} src={m.caseImage} alt="" />
                                    )}
                                </div>
                                <div className={c.actions}>
                                    <button className={c.editBtn} onClick={() => handleEdit(m)}>✏️</button>
                                    <button className={c.deleteBtn} onClick={() => handleDelete(m.id)}>🗑️</button>
                                </div>
                            </>
                        )}
                    </div>
                ))}
            </div>
        </div>
    )
}
